import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface EmployeesVerificationState {
  data: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | "update" | "get" | null;
}

const employeesVerificationInitialState: EmployeesVerificationState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getEmployeesVerification: any = createAsyncThunk(
  "get/employees-verifications",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.VERIFICATION_LIST,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);
// export const getEmployeesFaceVerificationHistory: any = createAsyncThunk(
//   "get/employees-verifications",
//   async (payload: any, thunkAPI) => {
//     try {
//       const response = await Api.post(
//         API_URLS.EMPLOYEES.VERIFICATION_LIST_HISTORY,
//         payload
//       );
//       return response.data;
//     } catch (error: any) {
//       const errorMessage =
//         error?.response?.data?.message || "Failed to fetch data.";
//       return thunkAPI.rejectWithValue(errorMessage);
//     }
//   }
// );

export const getEmployeesFaceVerificationHistory: any = createAsyncThunk(
  "get/employees-verifications",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.VERIFICATION_LIST_HISTORY,
        payload // payload: { empId?: string }
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const updateEmergencyContact = createAsyncThunk(
  "employee/updateEmergencyContact",
  async (payload, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.UPDATE_EMERGENCY_CONTACT,
        payload
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error as any));
    }
  }
);
export const getUpdateSettingAPI: any = createAsyncThunk(
  "get/employees-verifications",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.FIND_SETTING,
        payload // payload: { empId?: string }
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const updateSettingAPI: any = createAsyncThunk(
  "employee/setting",
  async (payload, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.UPDATE_SETTING,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const employeesVerificationUpdate: any = createAsyncThunk(
  "update/employees-verifications",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.UPDATE_VERIFICATION_STATUS,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const bulkUpdateEmployeesVerification: any = createAsyncThunk(
  "update/bulk-employees-verifications",
  async (payload: any, thunkAPI) => {
    try {
      console.log(payload, "bulkUpdateEmployeesVerification payload");
      const response = await Api.post(
        API_URLS.EMPLOYEES.BULK_UPDATE_VERIFICATION,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getDocument: any = createAsyncThunk(
  "get/employees-verifications-doc",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.EMPLOYEES.GET_DOC_URL, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const employeesVerificationSlice = createSlice({
  name: "reset",
  initialState: employeesVerificationInitialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.data = null;
      state.action = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getEmployeesVerification.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getEmployeesVerification.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getEmployeesVerification.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "list";
    });

    builder.addCase(employeesVerificationUpdate.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(employeesVerificationUpdate.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(employeesVerificationUpdate.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "update";
    });

    builder.addCase(bulkUpdateEmployeesVerification.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(bulkUpdateEmployeesVerification.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(bulkUpdateEmployeesVerification.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "update";
    });

    builder.addCase(getDocument.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "get";
    });
    builder.addCase(getDocument.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "get";
    });
    builder.addCase(getDocument.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "get";
    });
  },
});

export const { resetAll } = employeesVerificationSlice.actions;
export default employeesVerificationSlice.reducer;
